var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.818,
    height: 16,
    viewBox: "0 0 13.818 16",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "content-duplicate",
    d: "M8.545,12.636H3.455A1.455,1.455,0,0,1,2,11.182V2.455A1.455,1.455,0,0,1,3.455,1h8.727V2.455H3.455v8.727H8.545V9.727l2.909,2.182L8.545,14.091V12.636m5.818,2.909V5.364h-8V9.727H4.909V5.364A1.455,1.455,0,0,1,6.364,3.909h8a1.455,1.455,0,0,1,1.455,1.455V15.545A1.455,1.455,0,0,1,14.364,17h-8a1.455,1.455,0,0,1-1.455-1.455V14.091H6.364v1.455Z",
    transform: "translate(-2 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentDuplicate);
export default __webpack_public_path__ + "static/media/content_duplicate.59f8a3f3d1d23136e2b8e895d031db78.svg";
export { ForwardRef as ReactComponent };